export const GALLERY = [
  { id: 2, label: 'Modular Kitchen', sub: 'Contemporary Design' },
  { id: 5, label: 'Marble & Wood', sub: 'Premium Finish' },
  { id: 10, label: 'Open Kitchen', sub: 'Loft Series' },
  { id: 3, label: 'Shaker Style', sub: 'Classic Collection' },
  { id: 8, label: 'Built-In Wardrobe', sub: 'Storage Solutions' },
  { id: 14, label: 'Warm Oak Suite', sub: 'Lacquer Finish' },
];

export const STATS = [
  { value: '24', label: 'Active Projects' },
  { value: '12', label: 'Team Members' },
  { value: '156', label: 'Total Leads' },
  { value: '8', label: 'Pending Tasks' },
];

export const FEATURES = [
  {
    title: 'Project Management',
    desc: 'Track and manage all your interior projects with real-time status updates and milestone tracking.',
    img: 1,
  },
  {
    title: 'Team Collaboration',
    desc: 'Coordinate with designers, field officers, and installation teams through centralized communication.',
    img: 8,
  },
  {
    title: 'Lead Management',
    desc: 'Capture, track, and convert leads with integrated CRM and automated follow-up systems.',
    img: 12,
  },
];

export const WORKFLOW = [
  { step: '01', title: 'Capture Leads', desc: 'Incoming leads are automatically captured and assigned to team members for follow-up.' },
  { step: '02', title: 'Manage Projects', desc: 'Track project progress from design to installation with milestone tracking.' },
  { step: '03', title: 'Sales & Inventory', desc: 'Track inventory levels, handle supplier orders, and monitor sales operations seamlessly.' },
  { step: '04', title: 'Manage Documents', desc: 'Centralize your project files, track quotations, and organize essential records securely.' },
];

export const QUICK_ACCESS_ITEMS = [
  { id: 4, img: 4, label: 'Dashboard', path: '/' },
  { id: 6, img: 6, label: 'Projects', path: '/projects' },
  { id: 7, img: 7, label: 'Leads', path: '/leads' },
  { id: 9, img: 9, label: 'Team', path: '/users' },
  { id: 11, img: 11, label: 'Documents', path: '/documents' },
  { id: 13, img: 13, label: 'Inventory', path: '/inventory' },
  { id: 15, img: 15, label: 'Site Visits', path: '/site-visits' },
  { id: 16, img: 16, label: 'Analytics', path: '/analytics' },
  { id: 17, img: 17, label: 'Settings', path: '/settings' },
];
